import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class UpdateArbetsorderNamnCommand extends BasicCommand<UpdateArbetsorderNamnCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    namn: string;
    constructor(init: (instance: UpdateArbetsorderNamnCommand) => void) {
        super("UpdateArbetsorderNamnCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
